import { render, staticRenderFns } from "./OfficePendingReports.vue?vue&type=template&id=50ac0a83&scoped=true&"
import script from "./OfficePendingReports.vue?vue&type=script&lang=ts&"
export * from "./OfficePendingReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac0a83",
  null
  
)

export default component.exports